import React, { useState } from "react";
import AdminAppBody from "../../../../components/admin/AdminAppBody";

const AddAssessments = () => {
  const [includeMCQ, setIncludeMCQ] = useState(true);
  const [includeCoding, setIncludeCoding] = useState(true);
  const [assessmentType, setAssessmentType] = useState("Individual");
  const [mcqCount, setMcqCount] = useState("");
  const [codingCount, setCodingCount] = useState("");
  const [studentInput, setStudentInput] = useState("");

  const handleToggleMCQ = () => {
    setIncludeMCQ(!includeMCQ);
    if (includeMCQ) setMcqCount("");
  };

  const handleToggleCoding = () => {
    setIncludeCoding(!includeCoding);
    if (includeCoding) setCodingCount("");
  };

  return (
    <AdminAppBody
      content={
        <div className="container my-4">
          <h3 className="fw-bold mb-4">Create New Assessment</h3>
          <div className="card p-4 shadow-sm">
            {/* Program Selectors */}
            <div className="row mb-3">
              <div className="col-md-4">
                <label className="form-label">Program Type:</label>
                <select className="form-select">
                  <option>Select Program Type</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Program:</label>
                <select className="form-select">
                  <option>Select Program First</option>
                </select>
              </div>
              <div className="col-md-4">
                <label className="form-label">Module:</label>
                <select className="form-select">
                  <option>Select Program First</option>
                </select>
              </div>
            </div>

            {/* Assessment Config */}
            <div className="border rounded p-3 mb-4 bg-light">
              <h6 className="mb-3 fw-bold">Assessment Configuration</h6>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Difficulty Level</label>
                  <select className="form-select">
                    <option>Select Level</option>
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Total Questions</label>
                  <input type="number" className="form-control" />
                </div>

                {/* Toggle switches */}
                <div className="col-md-6 mb-3 d-flex align-items-center gap-2">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={includeMCQ}
                      onChange={handleToggleMCQ}
                    />
                    <label className="form-check-label">
                      Include MCQ Questions
                    </label>
                  </div>
                </div>

                <div className="col-md-6 mb-3 d-flex align-items-center gap-2">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={includeCoding}
                      onChange={handleToggleCoding}
                    />
                    <label className="form-check-label">
                      Include Coding Questions
                    </label>
                  </div>
                </div>

                {/* MCQ/Coding Inputs */}
                <div className="col-md-6 mb-3">
                  <label className="form-label">MCQ Questions Count</label>
                  <input
                    type="number"
                    className="form-control"
                    value={mcqCount}
                    onChange={(e) => setMcqCount(e.target.value)}
                    disabled={!includeMCQ}
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">Coding Questions Count</label>
                  <input
                    type="number"
                    className="form-control"
                    value={codingCount}
                    onChange={(e) => setCodingCount(e.target.value)}
                    disabled={!includeCoding}
                  />
                </div>

                <div className="col-12 mb-3">
                  <label className="form-label">Assessment Instructions</label>
                  <textarea className="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>

            {/* Assessment Type */}
            <div className="mb-3">
              <label className="form-label me-3">Assessment Type:</label>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  name="assessmentType"
                  value="Individual"
                  checked={assessmentType === "Individual"}
                  onChange={(e) => setAssessmentType(e.target.value)}
                />
                <label className="form-check-label">Individual</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  type="radio"
                  className="form-check-input"
                  name="assessmentType"
                  value="Group"
                  checked={assessmentType === "Group"}
                  onChange={(e) => setAssessmentType(e.target.value)}
                />
                <label className="form-check-label">Group</label>
              </div>
            </div>

            {/* Conditional student input */}
            <div className="mb-4">
              <label className="form-label">
                {assessmentType === "Individual"
                  ? "Student Name"
                  : "Group of Students"}
              </label>
              {assessmentType === "Individual" ? (
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter single student name"
                  value={studentInput}
                  onChange={(e) => setStudentInput(e.target.value)}
                />
              ) : (
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Enter group student names, separated by commas"
                  value={studentInput}
                  onChange={(e) => setStudentInput(e.target.value)}
                ></textarea>
              )}
            </div>

            {/* Buttons */}
            <div className="d-flex justify-content-between">
              <button className="btn btn-outline-secondary">← Cancel</button>
              <button className="btn btn-primary">
                🚀 Generate Assessment
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default AddAssessments;
